












import { Vue, Component, Prop } from 'vue-property-decorator';
import CommentTile from '@/components/business/comments/CommentTile.vue';
import CommentSwiper from '@/components/business/comments/CommentSwiper.vue';
@Component({
  components: {
    CommentTile,
    CommentSwiper,
  },
})
export default class Comments extends Vue {
  @Prop() commentsData!: object;
}
